import React, { useEffect, useState } from "react";
import Snackbar from "@mui/joy/Snackbar";
import PlaylistAddCheckCircleRoundedIcon from "@mui/icons-material/PlaylistAddCheckCircleRounded";
import Button from "@mui/material/Button";

const AlertMessage = ({alertMessage, alertType}) => {
  const [open, setOpen] = useState(true);
  console.log("mounted" +open);

  useEffect(() => {
    console.log(open);
  }, [open])
  
  return (
    <>
      <Snackbar
        variant="soft"
        color={alertType}
        open={open}
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        startDecorator={<PlaylistAddCheckCircleRoundedIcon />}
        endDecorator={
          <Button
            onClick={() => setOpen(false)}
            size="sm"
            variant="soft"
            color={alertType}
          >
            Dismiss
          </Button>
        }
      >
        {alertMessage}
      </Snackbar>
    </>
  );
};

export default AlertMessage;
